import { useQuery } from "@apollo/client";

import { REGAL_VOICE_DEFAULT_EVENTS } from "Pages/orchestration/Pages/journeys/JourneyEditPage/Components/JourneyBuilder/Components/JourneyActionsPanel/NodeEditorPanel/Components/Shared/FormItemInputs/constants";
import { getEventNames as GET_EVENT_NAMES, type EventNamesResponse } from "ServerData/EventSchema/queries";

export function getEventTypeKey(conditionalType: string): string {
    return conditionalType === "regalVoiceEvent" ? "regal_voice_event" : "track";
}

export function useEventNamesQuery(conditionalType: string): { loading: boolean; eventNames: string[] } {
    const eventType = getEventTypeKey(conditionalType);
    const { data, loading } = useQuery<EventNamesResponse>(GET_EVENT_NAMES, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "no-cache",
        variables: {
            eventType,
        },
    });

    const eventNames = data?.getEventNames.items || REGAL_VOICE_DEFAULT_EVENTS;

    return { loading, eventNames };
}
